<template>
  <div class="order-details">
    <img src="../../assets/images/zhifuchenggong.png" alt="" />
    <div class="hint-text">您的订单已经提交成功，请等待老师处理~</div>
    <div class="submit-order" @click="complete">完成</div>
  </div>
</template>

<script>
export default {
  methods:{
    complete(){
      // 回小程序推荐课程
      wx.miniProgram.redirectTo({url:"../../switchPage?into=1&flag=normal"});
    }
  }
};
</script>

<style lang="scss" scoped>
.order-details{
  position: absolute;
  top: 16%;
  width: 100%;
  // transform: translateY(-50%);
  img{
    width: 45%;
  }
  .hint-text{
    margin-top: 0.8rem;
    font-size: 14px;
    color: #666;
  }
  .submit-order {
    width: 80%;
    height: 48px;
    margin: 32% auto 0;
    line-height: 48px;
    background: linear-gradient(315deg, #ff6060 0%, #fb6460 100%);
    border-radius: 25px;
    text-align: center;
    font-weight: 500;
    color: #fff;
  }
}
</style>